module.exports = "<label class=oui-dropdown-group__label ng-bind=::$ctrl.label></label> <div ng-transclude></div> ";